<template>
  <SAlert
    id="registrationSuccess"
    class="s-registration__success"
    color="primary"
    size="lg"
  >
    <div class="s-registration__success--title">
      {{ tr("company_registration_form.thanks.title1") }}
    </div>
    <div class="s-registration__success--title">
      {{ tr("company_registration_form.thanks.title2") }}
    </div>
    <p class="s-registration__success--description-text">
      {{ tr("company_registration_form.thanks.text2") }}
    </p>

    <div class="s-registration__success--title">
      {{ tr("company_registration_form.thanks.contactTitle") }}
    </div>
    <p class="s-registration__success--contact-text">
      {{ tr("company_registration_form.thanks.contactText") }}
      <a
        class="s-registration__success--contact-link"
        :href="`${tr('company_registration_form.thanks.appointmentLink')}`"
        target="_blank"
      >
        {{ tr("company_registration_form.thanks.appointmentText") }}
      </a>
      {{ tr("company_registration_form.thanks.contactTextAfter") }}
    </p>
  </SAlert>
</template>

<script setup lang="ts">
import { onMounted } from "vue";

import { SAlert } from "@solvari/common-fe";
import { useI18nCompanyRegistrationForm } from "@solvari/translations";

const { tr } = useI18nCompanyRegistrationForm();

const scrollToView = () => {
  const element = document.querySelector("#registrationSuccess");
  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "center" });
  }
};

onMounted(() => {
  scrollToView();
});
</script>

<style lang="postcss">
.s-registration__success {
  &__envelope {
    @apply mb-4 mr-6 h-10 w-10 rounded-full border-4 border-primary-700 p-4 text-primary-700;
  }

  &--title:first-child {
    @apply text-2xl;
  }

  &--title {
    @apply mb-2 font-secondary text-xl font-bold;
  }

  &--description-text {
    @apply mb-6 flex text-lg;
  }

  &--contact-text {
    @apply text-lg leading-normal;
  }

  &--contact-link {
    @apply font-bold;
  }
}
</style>
